(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-cart-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pb-cart-upsells')) {
    customElements.define(
      'pb-cart-upsells',
      class PbCartUpsells extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', this.handleVariantChange);
          this.addEventListener('click', this.handleAdd);
        }

        handleVariantChange = (event) => {
          const select = event.target.closest('[data-pb-variant-select]');
          if (!select) return;

          const card = select.closest('[data-pb-upsell-card]');
          const option = select.selectedOptions[0];
          card.querySelector('[data-pb-compare-price]').textContent = option.dataset.comparePrice;
          card.querySelector('[data-pb-sale-price]').textContent = option.dataset.salePrice;
          card.querySelector('[data-pb-discount]').textContent = option.dataset.discountLabel;
        };

        handleAdd = async (event) => {
          const button = event.target.closest('[data-pb-upsell-add]');
          if (!button || button.disabled) return;

          const card = button.closest('[data-pb-upsell-card]');
          const select = card.querySelector('[data-pb-variant-select]');
          const variantId = select ? select.value : button.dataset.variantId;
          const error = this.querySelector('[data-pb-upsell-error]');
          const originalText = button.textContent;
          const addingText = this.querySelector('[data-pb-adding-text]').textContent;
          const cartDrawer = document.querySelector('cart-drawer');

          button.disabled = true;
          button.textContent = addingText;
          error.hidden = true;

          try {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            formData.append('properties[_Added from]', 'Cart drawer upsell');
            formData.append('properties[_Artwork source]', this.dataset.sourceTitle);

            if (cartDrawer) {
              formData.append(
                'sections',
                cartDrawer.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
              cartDrawer.setActiveElement(button);
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            const response = await fetch(window.routes.cart_add_url, config);
            const cartData = await response.json();

            if (!response.ok || cartData.status) {
              throw new Error(cartData.description || cartData.message);
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'pb-cart-upsells',
                productVariantId: variantId,
                cartData
              });
            }

            if (cartDrawer) {
              cartDrawer.renderContents(cartData);
            } else {
              window.location.href = window.routes.cart_url;
            }
          } catch (exception) {
            button.disabled = false;
            button.textContent = originalText;
            error.hidden = false;
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
